import React, { forwardRef } from 'react';
import { Button } from 'reactstrap';

const CustomButton = forwardRef((props, ref) => {
  const { label, className, disablecheck, iconbutton, width } = props;
  return (
    <Button
      innerRef={ref}
      color="primary"
      disabled={disablecheck}
      {...props}
      style={{ width: width }}
      className={`${iconbutton ? 'iconBtn ' : ''}${className ? className : ''}`}
    >
      {label}
    </Button>
  );
});

export default CustomButton;
